import React from "react";
function CustomLink(_a) {
    var to = _a.to, className = _a.className, children = _a.children;
    return to ? (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: to, className: className }, children)) : (React.createElement("div", { className: className }, children));
}
export default CustomLink;
